let sdkLoadPromise: Promise<void> | null = null;

const loadFacebookSdk = (): Promise<void> => {
  if (typeof window === 'undefined') return Promise.resolve();
  if ((window as any).FB) return Promise.resolve();
  if (sdkLoadPromise) return sdkLoadPromise;

  sdkLoadPromise = new Promise((resolve) => {
    (window as any).fbAsyncInit = () => {
      (window as any).FB.init({
        appId: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || '',
        cookie: true,
        xfbml: false,
        version: 'v24.0',
      });
      resolve();
    };

    if (document.getElementById('facebook-jssdk')) return;
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  });

  return sdkLoadPromise;
};

export const facebookLogin = async (): Promise<{ accessToken: string } | null> => {
  await loadFacebookSdk();
  const FB = (window as any).FB;
  if (!FB) return null;

  return new Promise((resolve) => {
    FB.login(
      (response: any) => {
        if (response?.authResponse?.accessToken) {
          resolve({ accessToken: response.authResponse.accessToken });
        } else {
          resolve(null);
        }
      },
      { scope: 'public_profile,email' }
    );
  });
};
